import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
	selector: 'app-pagination',
	styleUrls: ['./pagination.component.scss'],
	templateUrl: './pagination.component.html',
})
export class PaginationComponent implements OnInit {
	static defaultLimit: number = 10;

	@Input() count: number = 0;
	@Input() currentPage: number = 1;
	@Input() limit: number = PaginationComponent.defaultLimit;
	@Output() pageChange: EventEmitter<number> = new EventEmitter();
	@Input() totalPages: number = 1;

	maxPages: number = 3;
	pageQuantityFinal: number = this.limit;
	pageQuantityInitial: number = 1;

	get showEllipsis(): boolean {
		return (
			this.totalPages > this.maxPages && this.currentPage < this.totalPages
		);
	}

	checkQuantity(): void {
		this.pageQuantityInitial = this.currentPage * this.limit - this.limit + 1;

		if (this.currentPage === this.totalPages) {
			this.pageQuantityFinal = this.count;
		} else {
			this.pageQuantityFinal = this.currentPage * this.limit;
		}
	}

	ngOnInit() {
		this.checkQuantity();
	}

	onPageChange(page: number): void {
		this.currentPage = page;
		this.pageChange.emit(page);
		this.checkQuantity();
	}

	pagesArray(): number[] {
		let startPage: number = 1;
		let endPage: number = this.totalPages;

		if (this.totalPages > this.maxPages) {
			const halfMaxPages = Math.floor(this.maxPages / 2);
			startPage = Math.max(this.currentPage - halfMaxPages, 1);
			endPage = startPage + this.maxPages - 1;

			if (endPage > this.totalPages) {
				endPage = this.totalPages;
				startPage = Math.max(endPage - this.maxPages + 1, 1);
			}
		}

		return Array.from(
			{ length: endPage - startPage + 1 },
			(_, index) => startPage + index,
		);
	}
}
